import { unsettledBetsAPI } from "../service/AuthService";

const normalizedUsername = (value) => String(value || "").trim().toLowerCase();

const responseContent = (result) => {
  // Keep this in sync with Current Bets, whose API response is wrapped in
  // `response` and has a pageable `content` array.
  const response = result?.response || {};
  return Array.isArray(response) ? response : response?.content || [];
};

const betUsername = (bet) => bet?.userName || bet?.username || bet?.user_name || "";

export const getBetSide = (bet) => (bet?.back_rate || bet?.back_run ? "BACK" : "LAY");

export const loadPinnedChallengeBets = async (usernames) => {
  const pinnedUsernames = Array.from(
    new Map(
      (Array.isArray(usernames) ? usernames : [])
        .map((username) => String(username || "").trim())
        .filter(Boolean)
        .map((username) => [normalizedUsername(username), username])
    ).values()
  );

  if (!pinnedUsernames.length) return [];

  // Use the normal Current Bets request. Pinned usernames are intentionally
  // not sent to the API; matching is done below in the browser.
  const result = await unsettledBetsAPI({
    betStatus: "MATCHED",
    betType: "ALL",
    gameType: "SPORTS",
    isCasino: false,
    pageNumber: 0,
    pageSize: 100,
  });

  const responses = responseContent(result);

  const pinnedUserKeys = new Set(pinnedUsernames.map(normalizedUsername));
  const seenBets = new Set();

  return responses
    .filter((bet) => pinnedUserKeys.has(normalizedUsername(betUsername(bet))))
    .map((bet) => ({
      ...bet,
      betSide: getBetSide(bet),
      userRate: bet.back_rate ?? bet.lay_rate ?? bet.back_run ?? bet.lay_run ?? 0,
    }))
    .filter((bet, index) => {
      const key = String(
        bet.betId ||
          bet.id ||
          `${betUsername(bet)}-${bet.created_date}-${bet.event_name}-${bet.amount}-${index}`
      );
      if (seenBets.has(key)) return false;
      seenBets.add(key);
      return true;
    });
};
